import React, {useEffect} from "react";
import {Layout} from "antd";
import {useDispatch, useSelector} from "react-redux";
import HorizontalDefault from "../Topbar/HorizontalDefault/index";
import HorizontalDark from "../Topbar/HorizontalDark/index";
import InsideHeader from "../Topbar/InsideHeader/index";
import AboveHeader from "../Topbar/AboveHeader/index";
import BelowHeader from "../Topbar/BelowHeader/index";
import Topbar from "../Topbar/index";
import {footerText} from "../../util/config";
import App from "../../routes/index";
import Customizer from "../Customizer";
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR
} from "../../constants/ThemeSetting";
import NoHeaderNotification from "../Topbar/NoHeaderNotification/index";
import {useRouteMatch} from "react-router-dom";
import CircularProgress from "components/CircularProgress/index";
import {SetNavBarItems, updateWindowWidth} from "../../appRedux/actions";
import AppSidebar from "./AppSidebar";

const {Content, Footer} = Layout;

const LoadComponents=()=>{

  const {loading} = useSelector(({ LoadingCenter }) => LoadingCenter);
  return (
    loading ?
      <div className="gx-loader-view LoadingInCenter"
      
      
      style={{zIndex:99999}}>
        <CircularProgress/>
      </div> : null
  ) 
  
}

// class LoadComponent2 extends React.Component{
//   // {loading} = useSelector(({ LoadingCenter }) => LoadingCenter);
//   render(){
//     return (
//       this.props.LoadingCenter.loading ?
//         <div className="gx-loader-view LoadingInCenter">
//           <CircularProgress/>
//         </div> : null
//     ) 
//   }
// }

// const Uuauau=(store)=>{
//   return ({
//     LoadingCenter:store.LoadingCenter
//   })
// }

// const LoadComponent2Real=connect(Uuauau)(LoadComponent2)

const getContainerClass = (navStyle) => {
  switch (navStyle) {
    case NAV_STYLE_DARK_HORIZONTAL:
      return "gx-container-wrap";
    case NAV_STYLE_DEFAULT_HORIZONTAL:
      return "gx-container-wrap";
    case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
      return "gx-container-wrap";
    case NAV_STYLE_BELOW_HEADER:
      return "gx-container-wrap";
    case NAV_STYLE_ABOVE_HEADER:
      return "gx-container-wrap";
    default:
      return '';
  }
};

const getNavStyles = (navStyle) => {
  switch (navStyle) {
    case NAV_STYLE_DEFAULT_HORIZONTAL :
      return <HorizontalDefault/>;
    case NAV_STYLE_DARK_HORIZONTAL :
      return <HorizontalDark/>;
    case NAV_STYLE_INSIDE_HEADER_HORIZONTAL :
      return <InsideHeader/>;
    case NAV_STYLE_ABOVE_HEADER :
      return <AboveHeader/>;
    case NAV_STYLE_BELOW_HEADER :
      return <BelowHeader/>;
    case NAV_STYLE_FIXED :
      return <Topbar/>;
    case NAV_STYLE_DRAWER :
      return <Topbar/>;
    case NAV_STYLE_MINI_SIDEBAR :
      return <Topbar/>;
    case NAV_STYLE_NO_HEADER_MINI_SIDEBAR :
      return <NoHeaderNotification/>;
    case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR :
      return <NoHeaderNotification/>;
    default :
      return null;
  }
};

const MainApp = () => {
  const navStyle = useSelector(({settings}) => settings.navStyle);
  const {user, company, branch} = useSelector(({auth}) => auth);
  const userRolePOS = user?.UserRolePOS;
  const canLoadNavBarItems = Boolean(user && (userRolePOS === 2 || typeof userRolePOS === 'undefined'));
  const companyId = company?.id;
  const branchId = branch?.id;
  const match = useRouteMatch();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleResize = () => {
      dispatch(updateWindowWidth(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [dispatch]);

  useEffect(() => {
    if (canLoadNavBarItems) {
      let cancelled = false;
      let retryTimeout;
      let retryDelay = 2000;

      const loadNavBarItems = () => {
        debugger
        dispatch(SetNavBarItems()).catch(() => {
          if (cancelled) return;

          retryTimeout = setTimeout(loadNavBarItems, retryDelay);
          retryDelay = Math.min(retryDelay * 2, 30000);
        });
      };

      loadNavBarItems();

      return () => {
        cancelled = true;
        clearTimeout(retryTimeout);
      };
    }
  }, [branchId, canLoadNavBarItems, companyId, dispatch]);

  return (
    <Layout className="gx-app-layout">
      <AppSidebar navStyle={navStyle}/>
      <Layout>
        {getNavStyles(navStyle)}
        <Content className={`gx-layout-content ${getContainerClass(navStyle)} `}>
          <App match={match}/>
          <LoadComponents/>
          <Footer>
            <div className="gx-layout-footer-content gx-text-center">
              {footerText}
            </div>
          </Footer>
        </Content>
      </Layout>
      <Customizer/>
    </Layout>
  )
};
export default MainApp;

